import React from 'react'
const About = () => {
  return (
    <>
    {/* <Navbar /> */}
    <div style={{height:"300px"}}>About</div>
    </>
  )
}

export default About